import { render } from "./CdataV12EponTable.vue?vue&type=template&id=29dd493f&scoped=true"
import script from "./CdataV12EponTable.vue?vue&type=script&lang=js"
export * from "./CdataV12EponTable.vue?vue&type=script&lang=js"

import "./CdataV12EponTable.vue?vue&type=style&index=0&id=29dd493f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dd493f"]])

export default __exports__